import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, isRef as _isRef } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex pl-2 pt-3"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Click Add below to create your first channel.", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "flex pl-2 pt-3" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Setup a Channel to Receive Alerts", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Add")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cancel ")

import { userModule } from "../store/user";
import { computed, getCurrentInstance, onMounted, ref } from "vue";
import { UserChannel } from "../models/Channel";
import Twilio from "@/components/TwilioAdd.vue";
import Discord from "@/components/DiscordAdd.vue";
import Email from "@/components/EmailAdd.vue";
import Telegram from "@/components/TelegramAdd.vue";
import Moralis from "moralis";
import { ChannelModel } from "@/notifi_types";
import ChannelListItem from "./channelListItem.vue";
import { useUserChannelsStore } from "@/store/pinia_userChannel";
import { storeToRefs } from "pinia";

type ProviderData = Record<string, string | boolean | undefined>;


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userChannelsStore = useUserChannelsStore();
onMounted(() => {
  userChannelsStore.setupChannels();
});

const providerData = ref<ProviderData>({ to: undefined });
const name = ref("");
const intNewChannel = ref("");
const showAdd = ref(false);

const noChannels = computed(() => channels.value.length == 0);

const newChannel = computed({
  get() {
    return intNewChannel.value;
  },
  set(v: string) {
    intNewChannel.value = v;
    if (name.value == "") {
      if (v == "twilio") {
        name.value = "My SMS";
      } else name.value = "My " + v;
    }
  },
});

const {
  userChannels: channels,
  definedChannels: definedChannels,
  loading,
} = storeToRefs(userChannelsStore);

const availableChannels = computed((): ChannelModel[] => {
  let base = definedChannels.value;
  const cur = channels.value;
  const res: ChannelModel[] = base.filter((e) => {
    return (
      e.multiple ||
      !cur.some((curElem) => e.id === curElem.attributes.providerID)
    );
  });
  return res;
});

const addNotAllowed = computed((): boolean => {
  return availableChannels.value.length == 0;
});

const validName = computed((): boolean => {
  return name.value.length > 3;
});
const addValid = computed((): boolean => {
  return (
    validName.value &&
    newChannel.value.length > 0 &&
    providerData.value != undefined
  );
});

const setProviderData = (pd: ProviderData): void => {
  providerData.value = pd;
};

const add = async (): Promise<void> => {
  if (!userModule.user) {
    throw "Login required";
  }
  const c = UserChannel.spawn(
    name.value,
    userModule.user?.id,
    newChannel.value
  );
  c.setProviderData(providerData.value);
  var acl = new Moralis.ACL();
  acl.setReadAccess(Moralis.User.current().id, true);
  acl.setWriteAccess(Moralis.User.current().id, true);
  acl.setRoleReadAccess("admins", true);
  acl.setRoleWriteAccess("admins", true);
  c.setACL(acl);
  const context = { action: "insert" };
  c.save(null, { context: context }).then(
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    (uc: UserChannel) => {
      // Execute any logic that should take place after the object is saved.
      showAdd.value = false;
    },
    (error: { message: string }) => {
      // Execute any logic that should take place if the save fails.
      // error is a Moralis.Error with an error code and message.
      alert("Failed to create new object, with error code: " + error.message);
    }
  );
};

return (_ctx: any,_cache: any) => {
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_list = _resolveComponent("va-list")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_va_list, null, {
      default: _withCtx(() => [
        _createVNode(_component_va_inner_loading, { loading: _unref(loading) }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(channels), (userChannel) => {
              return (_openBlock(), _createBlock(ChannelListItem, {
                key: userChannel.id,
                userChannel: userChannel
              }, null, 8, ["userChannel"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _: 1
    }),
    (_unref(noChannels))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_va_button, {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (showAdd.value = true), ["prevent"])),
        disabled: _unref(addNotAllowed),
        size: "medium",
        "icon-right": "add",
        class: "mr-4"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(_component_va_modal, {
      modelValue: showAdd.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((showAdd).value = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.2"
    }, {
      header: _withCtx(() => [
        _hoisted_6
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_va_button, {
          onClick: _withModifiers(add, ["prevent"]),
          disabled: !_unref(addValid)
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick", "disabled"]),
        _createVNode(_component_va_button, {
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (showAdd.value = false), ["prevent"]))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createVNode(_component_va_select, {
            class: "pt-2",
            modelValue: _unref(newChannel),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(newChannel) ? (newChannel).value = $event : null)),
            label: "Provider",
            options: _unref(availableChannels),
            "track-by": "id",
            "value-by": "id",
            "text-by": "name"
          }, null, 8, ["modelValue", "options"]),
          (_unref(newChannel) == 'twilio')
            ? (_openBlock(), _createBlock(Twilio, {
                key: 0,
                onProviderData: setProviderData
              }))
            : _createCommentVNode("", true),
          (_unref(newChannel) == 'discord')
            ? (_openBlock(), _createBlock(Discord, {
                key: 1,
                onProviderData: setProviderData
              }))
            : _createCommentVNode("", true),
          (_unref(newChannel) == 'email')
            ? (_openBlock(), _createBlock(Email, {
                key: 2,
                onProviderData: setProviderData
              }))
            : _createCommentVNode("", true),
          (_unref(newChannel) == 'telegram')
            ? (_openBlock(), _createBlock(Telegram, {
                key: 3,
                onProviderData: setProviderData
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_va_input, {
            class: "pt-2",
            modelValue: name.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((name).value = $event)),
            label: "Channel Name",
            error: !_unref(validName)
          }, null, 8, ["modelValue", "error"])
        ])
      ]),
      _: 3
    }, 8, ["modelValue"])
  ], 64))
}
}

})